// extracted by mini-css-extract-plugin
module.exports = {"c-primary":"#68b92e","c-success":"#41b762","c-warning":"#edcb29","c-error":"#f67171","c-info":"#9d9d9d"};